import { useMutation } from "react-query";
import { addOfficeAppliance } from "../api/officeApplianceService";

const useAddOfficeAppliance = () => {
  return useMutation(addOfficeAppliance);
};
export default useAddOfficeAppliance;
